import { render } from "./UserRecurringSettings.vue?vue&type=template&id=4877d604"
import script from "./UserRecurringSettings.vue?vue&type=script&lang=js"
export * from "./UserRecurringSettings.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__